.cc{display:inline-flex;}